import React from 'react'

const TermsAndConditions = () => {
  return (
    <div className='container py-4'>
      <div className='bg-light p-4 rounded shadow-sm'>
        {' '}
        <h1 className='text-2xl font-bold mb-4'>Terms and Conditions</h1>
        <p>
          By accessing this website and using our services, you agree to be
          bound by the following terms:
        </p>
        <ul className='list-disc ml-6 my-4'>
          <li>
            All content on the website is for informational purposes only.
          </li>
          <li>
            Unauthorized use of this website may give rise to a claim for
            damages.
          </li>
          <li>
            You may not use our products for any illegal or unauthorized
            purpose.
          </li>
          <li>
            We reserve the right to update these terms without prior notice.
          </li>
        </ul>
        <p>
          If you do not agree with any part of these terms, please refrain from
          using our services.
        </p>
      </div>
    </div>
  )
}

export default TermsAndConditions
